/* UAG 2026-09-13: native carousel lifecycle; CSS tokens own spacing. */
if (!customElements.get('uag-category-carousel')) {
  customElements.define('uag-category-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.previous = this.querySelector('[data-previous]');
      this.next = this.querySelector('[data-next]');
      if (!this.track || !this.previous || !this.next) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const update = () => {
        const overflow = this.track.scrollWidth - this.track.clientWidth;
        const position = Math.abs(this.track.scrollLeft);
        this.previous.disabled = position <= 1;
        this.next.disabled = position >= overflow - 1;
      };
      const move = (direction) => {
        const card = this.track.firstElementChild;
        if (!card) return;
        const gap = Number.parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const rtl = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
        const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({
          left: direction * rtl * (card.getBoundingClientRect().width + gap),
          behavior: reducedMotion ? 'auto' : 'smooth',
        });
      };
      this.previous.addEventListener('click', () => move(-1), options);
      this.next.addEventListener('click', () => move(1), options);
      this.track.addEventListener('scroll', update, { ...options, passive: true });
      this.resizeObserver = new ResizeObserver(update);
      this.resizeObserver.observe(this.track);
      update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
    }
  });
}
